// #region Imports
import { Dialog } from '@radix-ui/themes';
import clsx from 'clsx';
import { AZButton } from '../AZButton';
import './AZModal.css';
import type { AZModalProps } from './AZModal.types';
// #endregion

// #region Component
/**
 * Accessible modal dialog built on Radix Themes Dialog.
 *
 * @example
 * <AZModal show={isOpen} onClose={() => setIsOpen(false)} bigTitle="Settings">
 *   <p>Modal content</p>
 * </AZModal>
 */
const AZModal = ({
  show,
  onClose,
  bigTitle,
  smallTitle,
  children,
  fullscreen = true,
  maxWidth,
}: AZModalProps) => {
  // #region Interface
  return (
    <Dialog.Root open={show} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Content
        className={clsx('az-modal-content', fullscreen && 'az-modal-fullscreen')}
        aria-describedby={undefined}
        data-fullscreen={fullscreen ? 'true' : undefined}
        maxWidth={maxWidth}
      >
        {(bigTitle != null || smallTitle != null) && (
          <div className="az-modal-header">
            <div className="az-modal-titles">
              {bigTitle != null && (
                <Dialog.Title className="az-modal-title">{bigTitle}</Dialog.Title>
              )}
              {smallTitle != null && (
                <Dialog.Description className="az-modal-small-title">
                  {smallTitle}
                </Dialog.Description>
              )}
            </div>
            <Dialog.Close>
              <AZButton variant="ghost" icon="X" aria-label="Close" />
            </Dialog.Close>
          </div>
        )}
        <div className="az-modal-body">{children}</div>
      </Dialog.Content>
    </Dialog.Root>
  );
  // #endregion
};
// #endregion

// #region Display Name
AZModal.displayName = 'AZModal';
// #endregion

export { AZModal };
